import { DownloadOutlined } from "@ant-design/icons";
import { Button, Card, Form, Image, Input, Modal, Skeleton } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { encrypt, formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function IdScannedAudit() {
    const searchRef = useRef(null);
    const transactionIDForScannedDoc = useRef(null);
    const [showIDImageForm, setShowIDImageForm] = useState(0); // 0 - hidden, 1 - showing, 2 - loading, 3 - showing image, 4 - Error While Fetching
    const [previewVisible, setPreviewVisible] = useState(false);
    const [transactionIDImage, setTransactionIDImage] = useState([]);
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "created_at",
    });
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
        page: 0,
        limit: 10,
        search_by: "",
    });
    const [transactionID, setTransactionID] = useState("");

    const columns = [
        {
            title: "Staff Name",
            dataIndex: "first_name",
            key: "first_name",
            sorter: true,
            sortOrder:
                sortedInfo.columnKey === "first_name" ? sortedInfo.order : null,
            render: (text, record) => (
                <span>
                    {record.first_name} {record.last_name}
                </span>
            ),
        },
        {
            title: "Operation ID",
            dataIndex: "operation_id",
            key: "operation_id",
            sorter: true,
            sortOrder:
                sortedInfo.columnKey === "operation_id"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Audit Date & Time",
            dataIndex: "created_at",
            key: "created_at",
            sorter: true,
            sortOrder:
                sortedInfo.columnKey === "created_at" ? sortedInfo.order : null,
            render: (text) => (
                <span>{formatDate(text, "YYYY/MM/DD hh:mm:ss a")}</span>
            ),
        },
    ];

    const {
        status: auditStatus,
        data: auditRes,
        refetch: fetchAuditDetails,
    } = useQuery(
        "IdScanAudit",
        async () => {
            return await HTTP("/staff/getScannedImagesInfo", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchAuditDetails();
    }, []);
    useEffect(() => {
        fetchAuditDetails();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (auditStatus === "success") {
            const { data: auditData, total } = auditRes;
            setTotalRecords(total);
            setTableData(auditData);
        }
    }, [auditStatus, auditRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };
        setFormData(newFormData);
    }

    const getIDForTransaction = async (operation_id, auth_values) => {
        const scanIDs = await HTTP("/staff/getScannedImages", {
            staff_id,
            operation_id,
            ...auth_values,
        });
        console.log("scanIDs.message", scanIDs);
        if (scanIDs.success == 0) {
            setShowIDImageForm(5);
            setTransactionIDImage(scanIDs.message);
            return;
        }
        if (
            (scanIDs.data[0].image_urls_multiple &&
                Array.isArray(scanIDs.data[0].image_urls_multiple)) ||
            (scanIDs.data[0].image_urls &&
                Array.isArray(scanIDs.data[0].image_urls))
        ) {
            if (scanIDs.data[0].image_urls_multiple.length > 0) {
                setTransactionIDImage(scanIDs.data[0].image_urls_multiple);
            } else {
                const formatted_imageURLs = scanIDs.data[0].image_urls.map(
                    (url, index) => ({ [index + 1]: [url] }),
                );
                setTransactionIDImage(formatted_imageURLs);
            }
        } else {
            console.log("error in fetching images");
            setTransactionIDImage("No ID Images Found for this Transaction");
            setShowIDImageForm(5);
            return;
        }
        setShowIDImageForm(4);
    };

    const handleDownload = (imageUrl) => {
        const link = document.createElement("a");
        link.href = imageUrl;
        console.log("imageUrl", imageUrl);
        link.download = "downloaded-image.png"; // Customize filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="box-shadow margin-10">
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingBottom: 20,
                    }}
                >
                    <div>
                        <Input
                            placeholder="Search by Staff Name"
                            style={{ width: 300 }}
                            ref={searchRef}
                        />
                        <Button
                            type="primary"
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                setFormData({
                                    ...formData,
                                    search_by: searchRef.current.input.value,
                                    page: 0,
                                });
                            }}
                        >
                            Search
                        </Button>
                    </div>
                    <Button
                        type="primary"
                        onClick={() => {
                            transactionIDForScannedDoc.current = null;
                            setShowIDImageForm(1);
                        }}
                    >
                        ID Retrieval
                    </Button>
                </div>
                {auditStatus === "loading" || auditStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="hotel_id"
                    />
                )}
            </Card>
            <Modal
                width={800}
                open={showIDImageForm !== 0}
                onCancel={() => {
                    console.log("closing modal");
                    setShowIDImageForm(0);
                    transactionIDForScannedDoc.current = null;
                    setTransactionID("");
                    fetchAuditDetails();
                }}
                destroyOnHidden
                footer=""
                title={"ID Of Transaction"}
            >
                {showIDImageForm == 1 && (
                    <div
                        className="id-image-form"
                        style={{ paddingBottom: "35px" }}
                    >
                        <Input
                            placeholder="Transaction ID"
                            className="margin-right-10"
                            ref={transactionIDForScannedDoc}
                        ></Input>
                        <Button
                            type="primary"
                            className="margin-top-10 float-right padding-bottom-10"
                            onClick={() => {
                                if (
                                    transactionIDForScannedDoc.current.input
                                        .value &&
                                    transactionIDForScannedDoc.current.input.value.trim() !==
                                        ""
                                ) {
                                    setShowIDImageForm(2);
                                    setTransactionID(
                                        transactionIDForScannedDoc.current.input
                                            .value,
                                    );
                                }
                            }}
                        >
                            Submit
                        </Button>
                    </div>
                )}
                {showIDImageForm == 2 && (
                    <div
                        className="id-image"
                        style={{
                            textAlign: "center",
                            width: "100%",
                        }}
                    >
                        <Form
                            layout="inline"
                            onFinish={(values) => {
                                console.log("values", values);
                                if (
                                    !values.email ||
                                    values?.email == undefined ||
                                    values?.email == "" ||
                                    !values.password ||
                                    values?.password == undefined ||
                                    values?.password == ""
                                ) {
                                    return;
                                }
                                getIDForTransaction(transactionID, {
                                    ...values,
                                    password: encrypt(values.password),
                                });
                                setShowIDImageForm(3);
                            }}
                        >
                            <Form.Item label="User Name" name={"email"}>
                                <Input type="text" id="email" />
                            </Form.Item>
                            <Form.Item label="Password" name={"password"}>
                                <Input type="password" id="password" />
                            </Form.Item>
                            <Form.Item
                                wrapperCol={{
                                    offset: 8,
                                    span: 16,
                                }}
                            >
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                )}
                {showIDImageForm == 3 && (
                    <div
                        className="id-image"
                        style={{
                            textAlign: "center",
                            width: "100%",
                        }}
                    >
                        <Skeleton.Image active />
                    </div>
                )}
                {showIDImageForm == 4 && (
                    <div
                        className="id-image"
                        style={{
                            textAlign: "center",
                            width: "100%",
                        }}
                    >
                        {transactionIDImage.map((imgObj, index) => {
                            return (
                                <>
                                    {Object.values(
                                        Object.values(imgObj)[0],
                                    ).map((img, idx) => {
                                        let finalImg = img;
                                        if (typeof img === "object") {
                                            finalImg = img.image;
                                        }
                                        return (
                                            <div
                                                key={idx}
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                }}
                                            >
                                                <Image
                                                    key={idx}
                                                    width={200}
                                                    src={finalImg}
                                                    preview={false}
                                                    onClick={() =>
                                                        setPreviewVisible(
                                                            !previewVisible,
                                                        )
                                                    }
                                                />
                                                <Button
                                                    type="primary"
                                                    icon={<DownloadOutlined />}
                                                    onClick={() =>
                                                        handleDownload(finalImg)
                                                    }
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundColor:
                                                            "rgba(0, 0, 0, 0.2)", // Semi-transparent black overlay
                                                        display: "flex",
                                                        justifyContent:
                                                            "center",
                                                        alignItems: "center",
                                                        color: "white",
                                                        fontSize: "15px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Download
                                                </Button>
                                            </div>
                                        );
                                    })}
                                </>
                            );
                        })}
                    </div>
                )}
                {showIDImageForm == 5 && <div>{transactionIDImage}</div>}
            </Modal>
        </Card>
    );
}

export { IdScannedAudit };
